import { DestroyRef, inject, signal } from '@angular/core';

export function injectFullscreen() {
  const destroyRef = inject(DestroyRef);
  const isFullscreen = signal(false);
  const handler = () => isFullscreen.set(!!document.fullscreenElement);

  // Sync state when the browser exits fullscreen independently (Esc, F11, tab switch)
  document.addEventListener('fullscreenchange', handler);
  destroyRef.onDestroy(() => document.removeEventListener('fullscreenchange', handler));

  return {
    fullscreenEnabled: document.fullscreenEnabled,
    isFullscreen: isFullscreen.asReadonly(),
    toggleFullscreen: (element?: HTMLElement) => {
      if (!document.fullscreenElement) {
        (element ?? document.documentElement).requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
  };
}
